import React from 'react';
import { Table } from 'semantic-ui-react';
import './RoomTypeColorCell.css';

const RoomRow = ({ item, onClick }) => (
  <Table.Row onClick={() => onClick(item)} className="line">
    <Table.Cell>{item.roomNumber}</Table.Cell>
    <Table.Cell>{item.revenue}</Table.Cell>
    <Table.Cell>{item.salesTaxSum}</Table.Cell>
    <Table.Cell>{item.occupancyTaxSum}</Table.Cell>
    <Table.Cell>{item.ownerUseValueRateToUse}</Table.Cell>
    <Table.Cell>{item.ownerUseValueToUse}</Table.Cell>
    <Table.Cell>{item.totalRevenuePlusOwnerUseValueToUse}</Table.Cell>
  </Table.Row>
);

export default React.memo(RoomRow);
